import { render, staticRenderFns } from "./BlogLoader.vue?vue&type=template&id=4f6b89db&scoped=true&"
import script from "./BlogLoader.vue?vue&type=script&lang=js&"
export * from "./BlogLoader.vue?vue&type=script&lang=js&"
import style0 from "./BlogLoader.vue?vue&type=style&index=0&id=4f6b89db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6b89db",
  null
  
)

export default component.exports